"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var BreadcrumbSeparator = function () {
    var theme = (0, material_1.useTheme)();
    return (react_1.default.createElement(material_1.Box, { sx: { color: theme.palette.grey[400], paddingX: 1.5 } }, "/"));
};
exports.default = BreadcrumbSeparator;
